import { Controller } from "@hotwired/stimulus";
import {
  createMap,
  fitBounds,
  removeMap,
  addReadOnlyGeomanControls,
  createLotLabel,
} from "../../helpers/map_helpers";

// Connects to data-controller="lots--show-map"
export default class extends Controller {
  static targets = ["container"];

  connect() {
    const polygonCoordinates = JSON.parse(this.element.dataset.polygon);
    const lotName = this.element.dataset.lotName || "Lot";
    const lotColor = this.element.dataset.lotColor || null;

    this.map = createMap(this.containerTarget);

    const polygonLayer = L.geoJSON(polygonCoordinates, {
      style: lotColor
        ? {
            fillColor: lotColor,
            fillOpacity: 0.35,
            color: lotColor,
            weight: 2,
          }
        : {},
    }).addTo(this.map);

    createLotLabel(this.map, lotName, polygonLayer, lotColor);

    fitBounds(this.map, [polygonLayer]);

    addReadOnlyGeomanControls(this.map);
  }

  disconnect() {
    removeMap(this.map);
    this.map = null;
  }
}
